let returnedSetupIntent: string | undefined;

/** Keep only the non-secret ID needed for server-side reconciliation. */
export function parseSignupPaymentReturn(pathname: string, search: string) {
  if (pathname !== "/onboarding") return null;
  const params = new URLSearchParams(search);
  const keys = [
    "setup_intent",
    "setup_intent_client_secret",
    "payment_intent",
    "payment_intent_client_secret",
    "redirect_status",
  ];
  if (!keys.some((key) => params.has(key))) return null;
  const candidate = params.get("setup_intent") || "";
  keys.concat("verification").forEach((key) => params.delete(key));
  return {
    setupIntentId: /^seti_[A-Za-z0-9]+$/.test(candidate)
      ? candidate
      : undefined,
    cleanUrl: `${pathname}${params.size ? `?${params}` : ""}`,
  };
}
function captureSignupPaymentReturn() {
  if (typeof window === "undefined") return;
  const result = parseSignupPaymentReturn(
    window.location.pathname,
    window.location.search,
  );
  if (!result) return;
  returnedSetupIntent = result.setupIntentId;
  window.history.replaceState(window.history.state, "", result.cleanUrl);
}
// Imported before App initializes analytics or begins authenticated requests.
captureSignupPaymentReturn();
export function takeSignupPaymentReturn() {
  captureSignupPaymentReturn();
  const result = returnedSetupIntent;
  returnedSetupIntent = undefined;
  return result;
}
